import axios from 'axios';

export const fetchUser = async (url, data) => {
    try {
        const response = await axios.get(`${url}/user/${data.id}/${data.secret}/${data.type}`);
        return response.data;
    } catch (error) {
        console.error("Error en fetchUser:", error);
        throw error.response.data; // Lanza el error para que se maneje fuera de la función
    }
}


export const fetchRegister = async (url, data) => {
    try {
        const response = await axios.post(`${url}/register`, data);
        return response.data;
    } catch (error) {
        console.error("Error en fetchRegister:", error);
        return error.response.data.message;
        // throw error.response.data; // Lanza el error para que se maneje fuera de la función
    }
}


export const fetchLogin = async (url, data) => {
    try {
        const response = await axios.post(`${url}/login`, data);
        return response.data;
    } catch (error) {
        console.error("Error en fetchRegister:", error);
        return error.response.data.message;
        // throw error.response.data; // Lanza el error para que se maneje fuera de la función
    }
}


export const validateTkn = async (url, data) => {
    try {
        const response = await axios.post(`${url}/validateTkn`, data, {
            headers: {
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error en validateTkn:", error);
        return error.response?.data?.message || "An error occurred";
        // Agregué un operador de encadenamiento opcional (?) para evitar errores si `error.response` es undefined
    }
};
